import Text14 from '@sdk/components/ui/typography/Text14';
import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { BreakAttestation } from '@sdk/automatedBreaks/types/Attestation';

import { useAttestationsToDisplay } from '@web/timeClock/modals/rows/AttestationsRow/attestationsRow.hooks';
import {
  AttestationEntry,
  TextWrap,
} from '@web/timeClock/modals/rows/AttestationsRow/attestationsFromSingleProjection.styles';

type Props = {
  breakAttestations: BreakAttestation[];
  withCaption?: boolean;
};
const AttestationsFromSingleProjection = ({ breakAttestations, withCaption = false }: Props) => {
  const attestationsToDisplay = useAttestationsToDisplay(breakAttestations, withCaption);
  const marginSize = withCaption ? 10 : 5;

  return (
    <Column>
      {attestationsToDisplay.map((attestation, index) => (
        <AttestationEntry mTop={index ? marginSize : 0} key={index}>
          {Boolean(attestation.caption) && (
            <Row mLeft={-8}>
              <Text14 themeColor={ThemeColorType.gray}>{attestation.caption}</Text14>
            </Row>
          )}
          <Text14 themeColor={ThemeColorType.gray} bold>
            ·&nbsp;
          </Text14>
          <Text14 themeColor={ThemeColorType.gray}>{attestation.text}</Text14>
          {Boolean(attestation.subText?.length) && (
            <Row mLeft={10}>
              <Text14 themeColor={ThemeColorType.gray}>-&nbsp;</Text14>
              <TextWrap themeColor={ThemeColorType.gray} bold>
                {attestation.subText}
              </TextWrap>
            </Row>
          )}
        </AttestationEntry>
      ))}
    </Column>
  );
};

export default AttestationsFromSingleProjection;
